import * as React from 'react';
import loadable from '@loadable/component';
import useTranslator from 'Client/hooks/useTranslator';
import withMicroFrontendProps, { SEOHead } from 'AppShell/Microfrontend';

const Wishlist = loadable(() => import('mf-wishlist/Main'), { ssr: true });

const WishlistWithBellaProps = withMicroFrontendProps(Wishlist, 'mf-wishlist');

const WishlistMicroFrontend = () => {
    const t = useTranslator();

    return (
        <div>
            <SEOHead noIndex>
                <title>
                    {t('My Wishlist')} | {t('SHOP_NAME')}
                </title>
            </SEOHead>
            <WishlistWithBellaProps />
        </div>
    );
};

export default WishlistMicroFrontend;
